export default __webpack_public_path__ + "static/media/animation-arrow6.9436b247.gif";